<script lang="ts" setup>
import { PublicDeliverySellerOne } from '@gql/PublicDeliverySellerOne'

const t2 = useT2({
  Weight: 'Svoris',
  Price: 'Kaina',
  Mainland: 'Žemyninė dalis',
})
const props = defineProps<{ deliveryid: string; input: gen.InputPublicDeliverySeller }>()

const { ui } = useApolloWrap2<gen.PublicDeliverySellerOneQuery, gen.PublicDeliverySellerOneQueryVariables>(PublicDeliverySellerOne)({
  vars() {
    const id = props.deliveryid
    if (!id) return
    return { input: props.input, id: { _id: id } }
  },
  ui: (i) =>
    helpers.arr(i?.publicDeliverySellerOne?.items, (item) => {
      const title: string[] = []
      if (item.type) title.push(item.type)
      if (item.all) title.push(t2('All'))
      if (item.mainland) title.push(t2('Mainland'))
      if (item.zoneTitle) title.push(item.zoneTitle)
      return {
        title: title.join(' '),
        prices: item.prices,
      }
    }),
})
</script>

<template>
  <div v-if="ui.length">
    <div v-for="item of ui">
      <div v-if="ui.length > 1 && item.title?.length" class="_h4 _pb1 _pt2">{{ item.title }}</div>
      <div v-if="item.prices?.length" :class="$style.prices">
        <div :class="$style.cell">{{ t2('Weight') }}</div>
        <div :class="$style.cell">{{ t2('Price') }}</div>
        <template v-for="(item2, index2) in item.prices" :key="index2">
          <div :class="[$style.cell, 'weight']">{{ item2.weightUi }}</div>
          <div :class="$style.cell">
            <b class="_mono _mark _fs09">{{ item2.price }}</b>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style module>
.prices {
  composes: global(_fs1);
  composes: global(_pb02);
  composes: global(_pl02);

  composes: global(_grid);
  grid-template: max-content / minmax(0, 9999fr) minmax(0, max-content);
}
.cell {
  composes: global(_h34);
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_pl14);
  composes: global(_pr14);

  border-bottom: 1px dashed var(--black-45);
  margin: 0 0 -1px -1px;
}
.cell:nth-last-child(-n + 2) {
  border-bottom: none;
}
.cell:nth-child(-n + 2) {
  font-weight: var(--fw-xl);
}
.cell:global(.weight) {
  color: var(--black-2);
}
</style>
